import script from "./ArtifactTypeInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./ArtifactTypeInput.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__
import QSelect from 'quasar/src/components/select/QSelect.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSelect});
